import { Grid, Box } from "@mui/material";
import HeroBentoCard from "./HeroBentoCard";
import InstallmentBentoCard from "./InstallmentBentoCard";
import NewArrivalsBentoCard from "./NewArrivalsBentoCard";
import WheelBentoCard from "./WheelBentoCard";

const desktop = [
  <HeroBentoCard />,
  <WheelBentoCard variant="desktop" />,
  <InstallmentBentoCard variant="desktop" />,
  <NewArrivalsBentoCard variant="desktop" />,
];

const mobile = [
  <NewArrivalsBentoCard variant="mobile" />,
  <WheelBentoCard variant="mobile" />,
  <InstallmentBentoCard variant="mobile" />,
];

export default function BentoSection(_props?: { isMobile?: boolean }) {
  return (
    <>
      <Grid container spacing={0} sx={{ userSelect: "none", display: { xs: "none", md: "flex" } }}>
        <Grid item xs={12}>
          <Box sx={{ borderRadius: 0, height: 500, backgroundColor: "background.default" }}>{desktop[0]}</Box>
        </Grid>
        <Grid item xs={4} sx={{ mt: -25, position: "relative" }}>
          <Box
            sx={{
              position: "absolute",
              top: -20,
              left: 0,
              width: 20,
              height: 20,
              backgroundColor: "background.default",
              pointerEvents: "none",
              mask: "radial-gradient(circle at top right, transparent 70%, black 72%)",
              WebkitMask: "radial-gradient(circle at top right, transparent 70%, black 72%)",
            }}
          ></Box>

          <Box sx={{ borderRadius: 0, height: "100%", pt: 3, pr: 3, backgroundColor: "background.default", borderTopRightRadius: 20 }}>
            {desktop[1]}
          </Box>
        </Grid>
        <Grid item xs={4} sx={{ position: "relative" }}>
          <Box
            sx={{
              position: "absolute",
              top: -20,
              left: 0,
              width: 20,
              height: 20,
              backgroundColor: "background.default",
              pointerEvents: "none",
              mask: "radial-gradient(circle at top right, transparent 70%, black 72%)",
              WebkitMask: "radial-gradient(circle at top right, transparent 70%, black 72%)",
            }}
          ></Box>
          <Box sx={{ borderRadius: 0, height: 260, pt: 3, backgroundColor: "background.default" }}>{desktop[2]}</Box>
        </Grid>
        <Grid item xs={4}>
          <Box sx={{ borderRadius: 0, height: 260, pt: 3, pl: 3, backgroundColor: "background.default" }}>{desktop[3]}</Box>
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ userSelect: "none", display: { xs: "flex", md: "none" } }}>
        <Grid item xs={12}>
          {mobile[0]}
        </Grid>
        <Grid item xs={6}>
          {mobile[1]}
        </Grid>
        <Grid item xs={6}>
          {mobile[2]}
        </Grid>
      </Grid>
    </>
  );
}
